import { match } from "ts-pattern";

import { BadgeVariant } from "@/components/Badge";

import { CertificationStatus } from "../../-constants";

export function getCertificationStatusBadgeVariant(
  status: CertificationStatus,
): BadgeVariant {
  return match(status)
    .with(CertificationStatus.EFFECTIVE, () => "primaryMuted" as const)
    .with(CertificationStatus.ARCHIVED, () => "errorMuted" as const)
    .exhaustive();
}
